import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useNavigate } from 'react-router-dom';

export function Creators() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-20 pb-12 bg-earth-900">
      <div className="container mx-auto px-4">
        {/* Coming Soon Hero */}
        <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center space-y-8"
          >
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display">
              Coming Soon
            </h1>
            
            <p className="text-xl text-sand-400 max-w-2xl mx-auto">
              We're curating a network of passionate creators who will bring unique and unforgettable experiences to life.
            </p>

           
          </motion.div>
        </div>

        {/* Background Pattern */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-texture opacity-5"></div>
        </div>
      </div>
    </div>
  );
}